
import React, { useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col } from "react-bootstrap";

import ConsultaConfiguracaoEmail from '../../../../../lib/json/consultas/ConfiguracaoEmail.json'
import ConsultaCentroCusto from '../../../../../lib/json/consultas/CentroCustoSSMA.json'

import LoadingSpinner from "../../../../components/LoadinSpinner";
import InputGeral from "../../../../components/InputGeral/Index";
import { useNavigate, useParams } from "react-router-dom";
import {ConsultaAPI} from "../../../../../backend/ConsultaAPI";
import SubmitForm from "../../../../components/SubmitForm";
import { ConsumoAPI_POST, ConsumoAPI_PUT } from "../../../../../backend/ConsumoAPI";
import { SucessoMsg } from "../../../../contents/VariaveisGlobais";
import SelectDinamico from "../../../../components/SelectDinamico";
import { toast } from "react-toastify";

function FichaConfiguracaoEmail(){
    const navigate = useNavigate();
    // define a exibição do Loading
    var [carregar, setCarregar] = useState(false);
    var [inclusao, setInclusao] = useState(true);

    const { idConfiguracaoEmail } = useParams();

    // Consulta do grid
    var consultaDefault  = ConsultaConfiguracaoEmail.consulta + (idConfiguracaoEmail ? ` WHERE Id = '${idConfiguracaoEmail}'` : '');

    var [campoNome, setCampoNome]   = useState([]);
    var [campoEmail, setCampoEmail]   = useState([]);
    var [campoCentroCusto, setCampoCentroCusto]   = useState([]);

    useEffect(() => {
        if (idConfiguracaoEmail){
            setInclusao(false)
            loadConfiguracaoEmail();
        }
    }, []);

    // Processa consulta do grid
    const loadConfiguracaoEmail = async () => {
        setCarregar(true);
        
        var retConsulta = await ConsultaAPI( consultaDefault );
        
        if (retConsulta.data){
            setCampoNome(retConsulta.data[0].Nome);
            setCampoEmail(retConsulta.data[0].Email);
            setCampoCentroCusto({value: retConsulta.data[0].CentroCustoId, label: retConsulta.data[0].DescricaoCentroCusto});
        }
        
        setCarregar(false);
    }

    const handleSalvar = async() =>{
        try {
            // Verificar se todos os campos obrigatórios foram preenchidos
            if (!campoNome || !campoEmail || !campoCentroCusto.value) {
                toast.warning('O prenchimento dos campos são obrigatórios.');
                return;
            }

            setCarregar(true);
            const rota = 'configuracaoEmail' + (inclusao ? '' : '/' + idConfiguracaoEmail);
    
            const retConsumo = await (inclusao
                ? ConsumoAPI_POST(rota, { nome: campoNome, email: campoEmail, centroCusto: campoCentroCusto.value })
                : ConsumoAPI_PUT(rota, { nome: campoNome, email: campoEmail, centroCusto: campoCentroCusto.value }));
    
            SucessoMsg(retConsumo.description);
        } catch (error) {
            console.error('Error in handleSalvar:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    }

    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text="Configuração Email"/>
            </Col>
            <Col md="6" xs="12">
                <InputGeral 
                    label="Nome"
                    tipo='text'
                    value={campoNome}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoNome(e.target.value)}
                />
            </Col>
            <Col md="3" xs="12">
                <InputGeral 
                    label="Email"
                    tipo='email'
                    value={campoEmail}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoEmail(e.target.value)}
                />
            </Col>
            <Col md="3" xs="12">
                <SelectDinamico 
                    label="Centro de Custo"
                    consulta={ConsultaCentroCusto.consulta}
                    tabela={ConsultaCentroCusto.tabelas}
                    cValue="CTT_CUSTO"
                    cText='CTT_CUSTO + " - " + item.CTT_DESC01'
                    isMultiplo={false}
                    campoValue={campoCentroCusto}
                    value={campoCentroCusto}
                    showNoFilter={false}
                    onchange={(e) => setCampoCentroCusto(e)}
                />
            </Col>
        </Row>
        
        <SubmitForm onSave={handleSalvar} onCancel={"handleCancelar"}></SubmitForm>
        </>
    );
}

export default FichaConfiguracaoEmail;